__webpack_require__.p = "https://cdn.xsolla.net/";